import { combineReducers } from 'redux';
import uiReducer from './Interface';
import parcelDataReducer from './ParcelData';
import parcelDetailReducer from './ParcelDetail';

const rootReducer = combineReducers({
    ui: uiReducer,
    parcelData: parcelDataReducer,
    parcelDetail: parcelDetailReducer,
});

export default rootReducer;
